import React, { useState, useEffect } from "react";
import "./Carousel.css";

// Intervalo padrao entre as trocas automaticas (em milissegundos)
const DEFAULT_ROTATION_INTERVAL = 9000;

const Carousel = (props: {
  images: string[];
  width?: number;
  minWidth: number;
  rotationInterval?: number;
}) => {
  const {
    images,
    width,
    minWidth,
    rotationInterval = DEFAULT_ROTATION_INTERVAL,
  } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused || images.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, rotationInterval);

    return () => clearInterval(interval);
  }, [images.length, rotationInterval, isPaused]);

  return (
    <div
      className="carousel-container"
      style={{ width: `${width ? width : 100}%`, minWidth: minWidth }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="carousel-slide"
        style={{ transform: `translateX(${-currentIndex * 100}%)` }}
      >
        {images.map((imageUrl, index) => (
          <div key={index} className="carousel-image">
            <img src={imageUrl} alt={`Imagem ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
